import { render, staticRenderFns } from "./secondaryPageSetup.vue?vue&type=template&id=d480339a&scoped=true"
import script from "./secondaryPageSetup.vue?vue&type=script&lang=js"
export * from "./secondaryPageSetup.vue?vue&type=script&lang=js"
import style0 from "./secondaryPageSetup.vue?vue&type=style&index=0&id=d480339a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d480339a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d480339a')) {
      api.createRecord('d480339a', component.options)
    } else {
      api.reload('d480339a', component.options)
    }
    module.hot.accept("./secondaryPageSetup.vue?vue&type=template&id=d480339a&scoped=true", function () {
      api.rerender('d480339a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/appBasicSetup/secondaryPageSetup.vue"
export default component.exports